<script lang="ts">
    import { onDestroy, onMount } from "svelte";

    import Button from "../materialize/components/Button.svelte";
    import Icon from "../materialize/components/Icon.svelte";
    import Column from "../materialize/grid/Column.svelte";
    import Row from "../materialize/grid/Row.svelte";
    import { is_online } from "../stores/stores";
    import { get_host } from "../settings";
    import Divider from "../materialize/grid/Divider.svelte";
import SendEmailButton from "../utils/SendEmailButton.svelte";

    const connection_check_interval = setInterval(() => {
        fetch(get_host() + "/", { method: "HEAD" }).then((r) => {
            $is_online = true;
        });
    }, is_homepage ? 3000 : 3000);

    onDestroy(() => {
        if (is_homepage()) {
            // Homepage? Need full reload
            location.reload();
        }
        clearInterval(connection_check_interval);
    });

    function is_homepage():boolean
    {
        return window.location.hash == "" || window.location.hash == "#/";
    }
</script>

<div class="valign-wrapper" style="height:30vh;width=100vw">
    <div class="row center-align">
        <Icon class_list={["large"]} icon="cloud_off" />
    </div>
</div>
<Row>
    <Column small={12}>
        <h4 class="center-align">Problema di connessione</h4>
        <Divider />
    </Column>

    <!-- <Column small={12} medium={6} large={4}>
        <h4>Cosa è successo?</h4>
        <p>
            Non stiamo riuscendo a contattare il server appröu per fornirti le
            traduzioni
        </p>
    </Column> -->
    <Column small={12}>
        <h5 class="center-align">Controlla la tua connessione internet</h5>
        <!-- <p>
            Verifica la tua connessione internet. È molto probabile che tu non
            sia collegatə a internet.
        </p>
        <p>
            Forse la tua connessione in questo momento potrebbe essere troppo
            lenta
        </p>
        <p>Dopo che hai controllato la connessione, prova a ricaricare la pagina o chiudere e riaprire completamente l'app</p> -->
    </Column>
    <Column small={12}>
        <p class="center-align">Se sei sicuro che la tua connessione funzioni correttamente, puoi scriverci una mail per segnalarci il problema.</p>
        <div class="center-align">
            <SendEmailButton
                button_text="Segnala"
                mail_subject="Segnala problema"
                class_list={["center-align", "approu-primary"]}>
            </SendEmailButton>
        </div>
    </Column>
</Row>
